import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../../lib/api-client';
import { useAuthStore, type SessionUser } from '../../shared/auth/authStore';

export type { SessionUser };

export const SESSION_QUERY_KEY = ['session'] as const;

/** Nạp phiên server-side; frontend không giữ access/refresh token. */
export function useSession() {
  const setUser = useAuthStore((s) => s.setUser);
  return useQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get<SessionUser>('/auth/session');
      const user = ((data as { data?: SessionUser }).data ?? data) as SessionUser;
      setUser(user);
      return user;
    },
    retry: false,
    staleTime: 60_000,
  });
}
